import React, { useContext, useMemo } from 'react';

import { makeStyles } from '@mui/styles';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { PatientTabsContext } from '../../../lib/contexts';
import useMetric from '../../../lib/hooks/useMetric';
import { AdminProgressBar } from '../../../components/AdminProgressBar';
import { AdminChip } from '../../../components/AdminChip';
import { Add } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  patientChartCard: theme.globalClasses.patientChartCard,
  container: {
    maxHeight: 120,
    overflowY: 'scroll',
  },
  topBar: {
    marginBottom: 10,
  },
  addList: {
    fontSize: 18,
    marginBottom: -5,
    fontWeight: 'bold',
  },
}));

const PatientRecommendedResourcesBox = () => {
  const classes = useStyles();
  const {
    state: { currentTab },
  } = useContext(PatientTabsContext);
  const { isLoading, data } = useMetric('associated_admins', currentTab.id);
  return (
    <Grid
      item
      xs={12}
    >
      <Paper className={classes.patientChartCard}>
        <Typography
          variant={'h2'}
          className={classes.topBar}
        >
          Recommended Resources
        </Typography>
        {isLoading ? (
          <AdminProgressBar />
        ) : (
          <Box className={classes.container}>
            {data &&
              data.metric &&
              data.metric.value.map((item, index) => {
                return (
                  <AdminChip
                    key={index}
                    label={item.name}
                  />
                );
              })}
            <AdminChip
              label={
                <>
                  <Add className={classes.addList} />
                  &nbsp;Add
                </>
              }
              clickable
              onClick={() => {}}
            />
          </Box>
        )}
      </Paper>
    </Grid>
  );
};

export default PatientRecommendedResourcesBox;
